module.exports = {"locale":{"type":"min","content":[{"sub":"{city}, {country}","body":""}],"title":"locale"},"Onboarding":{"type":"full","content":[{"sub":"","body":"From here you can onboard a new building to be monitored by BreeziPro's AirPulse  devices."}],"title":"Onboarding"}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/hoverTemplates/Org.json
// module id = 410
// module chunks = 1